export default "__VITE_ASSET__CsbEABMX__"